export default {
  activities: [],
  pagination: {},
  activitie: {}
}
